import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: 100%;
  margin: auto;
  border-radius: 24px;
  background: #fff;
  overflow: scroll;
  position: relative;
  .standing-chart-header {
    padding: 0 1rem;
    border-bottom: 4px solid rgb(126, 126, 126);
    width: calc(100% - 2rem);
    background: #fff;
    .title {
      font-weight: 700;
    }
    .standing-chart-header-options {
      position: relative;
      .standing-chart-header-options-popup {
        position: absolute;
        display: none;
        background: white;
        padding: 1rem;
        p:hover {
          background: gray;
          cursor: pointer;
        }
        &.active {
          display: block;
        }
      }
      p span {
        color: #ff6a00;
      }
      #span-LA {
        cursor: pointer;
        &::after {
          content: "^";
        }
      }
    }
  }

  .table-container {
    overflow-x: scroll;
    table {
      width: 100%;
      padding: 0 1rem;
      border-collapse: collapse;
      thead {
        border-bottom: 2px solid #ff6a00; /* Replace with desired color code */
        th {
          padding: 0.5rem 1rem;
        }
        tr {
          text-align: left;
        }
      }
      tbody {
        color: rgb(126, 126, 126);
        font-size: 15px;
        td {
          padding: 0.3rem 1rem;
        }
        .activeRow {
          font-size: 16px;
          color: black;
        }
      }
    }
  }
  @media only screen and (min-width: 867px) {
  }
`;
